<div class="menuTriger" id="headTriger">
    <a mdbBtn floating="true" size="sm" gradient="blue" mdbWavesEffectj (click)="showHeader()">
        <i class="fa fa-arrow-up" id="headTrigerIcon"></i>
    </a>
</div>

<div class="row">
    <!-- Left Column-->
    <div class="col-xl-7 col-lg-7 mb-7 ">
        <div *ngIf='(viewStateAgents$ | async) as a'>
            <div *ngIf='a.isLoading'>
                <div class="alert alert-info" role="alert">
                    <div class="text-center">
                        <h3><strong>Loading Agent Board...</strong>
                        </h3>
                    </div>
                </div>
            </div>
            <div *ngIf='a.isError'>
                <div class="alert alert-danger" role="alert">
                    <div class="text-center">
                        <h3><strong>Agent Board Error - {{a.errorMessage}}</strong>
                        </h3>
                    </div>
                </div>
            </div>
            <div *ngIf='a.isLoaded'>
                <div *ngIf='!a.agents'>
                    <div class="alert alert-success" role="alert">
                        <div class="text-center">
                            <h3><strong>Agent Board Data - Not found.</strong>
                            </h3>
                        </div>
                    </div>
                </div>
                <div *ngIf='a.minutesFromLastUpdate > 5'>
                    <div class="alert alert-danger" role="alert">
                        <div class="text-center">
                            <h3><strong>Agent Board Data not updated for {{a.minutesFromLastUpdate}} minutes</strong>
                            </h3>
                        </div>
                    </div>
                </div>
                <div *ngIf='a.agents'>
                    <div class="card card-cascade narrower">
                        <mdb-card>
                            <div
                                class="view view-cascade gradient-card-header blue-gradient narrower py-0 mx-4 mb-3 d-flex justify-content-between align-items-center">
                                <div class="last-update-date">{{a.LastUpdated}}</div>
                                <div class="board-name">Agents Not Ready</div>
                                <div>
                                    <a mdbBtn floating="true" size="sm" class="color-block morpheus-den-gradient"
                                        mdbWavesEffectj (click)="triggerAgentNotReadyRows()">
                                        <i class="fa fa-arrow-down" id="agentNotReadyTrigger"></i>
                                    </a>
                                </div>
                            </div>
                            <mdb-card-body class="card-body-top-pos">
                                <mdb-card-text>
                                    <div *ngIf='a.isNotFound && a.minutesFromLastUpdate <= 5 && !a.isError'>
                                        <div class="alert alert-success" role="alert">
                                            <div class="text-center">
                                                <h3><strong>All Agents Working</strong>
                                                </h3>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="table-responsive" *ngIf='!a.isNotFound'>
                                        <table class="table large-header" mdbTable small="true" striped="true">
                                            <thead>
                                                <tr>
                                                    <th class="theader-style column-alphanumeric">Name</th>
                                                    <th class="theader-style column-alphanumeric">Reason</th>
                                                    <th class="theader-style column-numeric">Length</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr *ngFor="let ag of a.agents | slice:0:maximumSkillSetsAgent;">
                                                    <td class="tbody-style column-alphanumeric"
                                                        [ngClass]="{'danger-cell' : ag.WarningLevel === 1}">{{ag.Name}}
                                                    </td>
                                                    <td class="tbody-style column-alphanumeric">{{ag.Description}}</td>
                                                    <td class="tbody-style column-numeric">{{ag.Time}}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </mdb-card-text>


                            </mdb-card-body>
                        </mdb-card>
                    </div>
                </div>
            </div>
        </div>
        <br />
    </div>
    <!-- Right Column-->
    <div class="col-xl-5 col-lg-5 mb-5 ">
        <!-- Call Service Level-->

        <div *ngIf='(viewStateCall$ | async) as c'>
            <div *ngIf='c.isLoading'>
                <div class="alert alert-info" role="alert">
                    <div class="text-center">
                        <h3><strong>Loading Call Service Level Board...</strong>
                        </h3>
                    </div>
                </div>
            </div>
            <div *ngIf='c.isError'>
                <div class="alert alert-danger" role="alert">
                    <div class="text-center">
                        <h3><strong>Call Service Level Board Error - {{c.errorMessage}}</strong>
                        </h3>
                    </div>
                </div>
            </div>
            <div *ngIf='c.isLoaded'>
                <div *ngIf='c.minutesFromLastUpdate > 5'>
                    <div class="alert alert-danger" role="alert">
                        <div class="text-center">
                            <h3><strong>Call Service Level Board Data not updated for {{c.minutesFromLastUpdate}}
                                    minutes</strong>
                            </h3>
                        </div>
                    </div>
                </div>
                <div *ngIf='c.skillsets'>
                    <div class="card card-cascade narrower">
                        <mdb-card>
                            <div
                                class="view view-cascade gradient-card-header blue-gradient narrower py-0 mx-4 mb-3 d-flex justify-content-between align-items-center">
                                <div class="last-update-date">{{c.LastUpdated}}</div>
                                <div class="board-name">Call Service Level</div>
                                <div>
                                    <a mdbBtn floating="true" size="sm" class="color-block morpheus-den-gradient"
                                        mdbWavesEffectj (click)="triggerCallServiceLevelRows()">
                                        <i class="fa fa-arrow-down" id="callServiceLevelTrigger"></i>
                                    </a>
                                </div>
                            </div>
                            <mdb-card-body class="card-body-top-pos">
                                <mdb-card-text>
                                    <div *ngIf='c.isNotFound && c.minutesFromLastUpdate <= 5 && !c.isError'>
                                        <div class="alert alert-success" role="alert">
                                            <div class="text-center">
                                                <h3><strong>All Call Service Levels 100%</strong>
                                                </h3>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="table-responsive" *ngIf='!c.isNotFound'>
                                        <table class="table large-header" mdbTable small="true" striped="true">
                                            <thead>
                                                <tr>
                                                    <th class="theader-style column-alphanumeric">Skillset Name</th>
                                                    <th class="theader-style column-numeric">Service Level</th>
                                                    <th class="theader-style column-numeric">Max Wait</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr *ngFor="let psl of c.skillsets | slice:0:maximumSkillSetsPhone;">
                                                    <td class="tbody-style column-alphanumeric" [ngClass]="{'warning-cell' : psl.WarningLevel === 1,
                                                        'danger-cell' : psl.WarningLevel === 2}">
                                                        <span class="priority-text">P{{psl.Priority}}</span>&nbsp;{{psl.Name}}</td>
                                                    <td class="tbody-style column-numeric">{{psl.ServiceLevel}}
                                                    </td>
                                                    <td class="tbody-style column-numeric">{{psl.MaximumWaitTime}}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </mdb-card-text>


                            </mdb-card-body>
                        </mdb-card>
                    </div>
                </div>
            </div>
        </div>

        <!-- Email Service Level-->
        <br />
        <div *ngIf='(viewStateEmail$ | async) as e'>
            <div *ngIf='e.isLoading'>
                <div class="alert alert-info" role="alert">
                    <div class="text-center">
                        <h3><strong>Loading Email Service Level Board...</strong>
                        </h3>
                    </div>
                </div>
            </div>
            <div *ngIf='e.isError'>
                <div class="alert alert-danger" role="alert">
                    <div class="text-center">
                        <h3><strong>Email Service Level Error - {{e.errorMessage}}</strong>
                        </h3>
                    </div>
                </div>
            </div>
            <div *ngIf='e.isLoaded'>
                <div *ngIf='e.minutesFromLastUpdate > 5'>
                    <div class="alert alert-danger" role="alert">
                        <div class="text-center">
                            <h3><strong>Email Service Level Data not updated for {{e.minutesFromLastUpdate}}
                                    minutes</strong>
                            </h3>
                        </div>
                    </div>
                </div>
                <div *ngIf='e.skillsets'>
                    <div class="card card-cascade narrower">
                        <mdb-card>
                            <div
                                class="view view-cascade gradient-card-header blue-gradient narrower py-0 mx-4 mb-3 d-flex justify-content-between align-items-center">
                                <div class="last-update-date">{{e.LastUpdated}}</div>
                                <div class="board-name">Email Service Level</div>
                                <div>
                                    <a mdbBtn floating="true" size="sm" class="color-block morpheus-den-gradient"
                                        mdbWavesEffectj (click)="triggerEmailsServiceLevelRows()">
                                        <i class="fa fa-arrow-down" id="emailsServiceLevelTrigger"></i>
                                    </a>
                                </div>
                            </div>
                            <mdb-card-body class="card-body-top-pos">
                                <mdb-card-text>
                                    <div *ngIf='e.isNotFound && e.minutesFromLastUpdate <= 5 && !e.isError'>
                                        <div class="alert alert-success" role="alert">
                                            <div class="text-center">
                                                <h3><strong>All Email Service Levels 100%</strong>
                                                </h3>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="table-responsive" *ngIf='!e.isNotFound'>
                                        <table class="table large-header" mdbTable small="true" striped="true">
                                            <thead>
                                                <tr>
                                                    <th class="theader-style column-alphanumeric">Skillset Name</th>
                                                    <th class="theader-style column-numeric">Service Level</th>
                                                    <th class="theader-style column-numeric">Max Wait</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr *ngFor="let esl of e.skillsets | slice:0:maximumSkillSetsEmail;">
                                                    <td class="tbody-style column-alphanumeric" [ngClass]="{'warning-cell' : esl.WarningLevel === 1,
                                                        'danger-cell' : esl.WarningLevel === 2}">
                                                        <span class="priority-text">P{{esl.Priority}}</span>&nbsp;{{esl.Name}}
                                                    </td>
                                                    <td class="tbody-style column-numeric">{{esl.ServiceLevel}}
                                                    </td>
                                                    <td class="tbody-style column-numeric">{{esl.MaximumWaitTime}}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </mdb-card-text>


                            </mdb-card-body>
                        </mdb-card>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>